// extracted by mini-css-extract-plugin
export default {"loading-state__container":"styles_loading-state__container__lCjq0","loading-state__image":"styles_loading-state__image__+5qvN","spin":"styles_spin__DhI86"};